/** Page-size resolution for print preview and PNG rendering. */

import {
  DEFAULT_INVOICE_PAGE_SIZE,
  INVOICE_PAGE_SIZES,
  INVOICE_PRINT_STYLES,
  type InvoicePageSize,
  type InvoicePageSizeId,
} from "../constants/invoice";

export const resolveInvoicePageSize = (id?: string | null): InvoicePageSize => {
  if (id && id in INVOICE_PAGE_SIZES) {
    return INVOICE_PAGE_SIZES[id as InvoicePageSizeId];
  }
  return INVOICE_PAGE_SIZES[DEFAULT_INVOICE_PAGE_SIZE];
};

export const isKnownInvoicePageSize = (id: string): id is InvoicePageSizeId => id in INVOICE_PAGE_SIZES;

export const mmToPx = (millimetres: number, dpi = 96): number =>
  Math.round((millimetres / 25.4) * dpi);

/** CSS `@page` rule for the selected layout — consumed by the print route. */
export const buildPrintPageRule = (
  pageSize: InvoicePageSize,
  marginMm: number = INVOICE_PRINT_STYLES.pageMarginMm,
): string => `@page { size: ${pageSize.cssPageSize}; margin: ${marginMm}mm; }`;

export interface InvoiceSheetStyle {
  width: string;
  minHeight: string;
  padding: string;
  fontSize: string;
}

/** Physical sheet dimensions for on-screen preview (screen uses px, print uses mm). */
export const invoiceSheetStyle = (pageSize: InvoicePageSize): InvoiceSheetStyle => ({
  width: `${pageSize.widthMm}mm`,
  minHeight: pageSize.isReceipt ? "auto" : `${pageSize.heightMm}mm`,
  padding: `${INVOICE_PRINT_STYLES.pageMarginMm}mm`,
  fontSize: pageSize.isReceipt
    ? `${INVOICE_PRINT_STYLES.receiptFontPt}pt`
    : `${INVOICE_PRINT_STYLES.bodyFontPt}pt`,
});

export const invoiceAssetDimensions = (pageSize: InvoicePageSize) => ({
  width: mmToPx(pageSize.widthMm),
  height: mmToPx(pageSize.heightMm),
});
